import { Box, Button, DialogActions, DialogContent, Divider,Stack, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { CopyToClipboard } from 'common/components/CopyToClipboard';
import { PopOver } from 'common/components/PopOver';

import { closeSuccessDialog, selectSuccessDialog } from './apiKeysSlice';

export function ApiKeyCreateSuccessPopup() {
    const dispatch = useAppDispatch();
    const dialogState = useAppSelector(selectSuccessDialog);

    const onClose = () => {
        dispatch(closeSuccessDialog());
    };

    return <PopOver
        title='The API Key was successfully created'
        open={dialogState.open}
        onClose={onClose}
    >
        <DialogContent sx={{ textAlign: 'center' }}>
            <Typography color="info.light">
                Below is the API Key secret value which should be stored
                in a secure location. The value cannot be retrieved after
                this window is closed
            </Typography>

            <br />

            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <CopyToClipboard content={dialogState.createValue ?? ''} />
                {dialogState.createValue}
            </Box>
        </DialogContent>

        <Divider />

        <DialogActions sx={{ display: 'flex', justifyContent: 'center', margin: '9px' }}>
            <Stack direction="row" spacing={2}>
                <Button variant="contained" color="error" onClick={onClose} >
                    Okay
                </Button>
            </Stack>
        </DialogActions>
    </PopOver>;
}
